<template>
  <v-app>
    <v-container>
      <v-row>
        <v-col cols="10" offset="1">
          <v-card class="pa-4">
            <v-row>
              <v-col cols="12">
                <v-card flat class="d-flex align-start justify-space-between" style="border-bottom: 2px solid #eee;">
                  <div>
                    <h4 class="text-uppercase font-weight-bold mb-1">Remex Corporation Ltd.</h4>
                    <div class="text-subtitle-2">Red Crescent Concord Tower 17, Unit 10/B</div>
                    <div class="text-subtitle-2">Mohakhali C/A, Dhaka-1212, Bangladesh</div>
                    <div class="text-subtitle-2">📞 +88-02222288648, +88-02222289278</div>
                    <div class="text-subtitle-2">✉️ info@remexcorp.com</div>
                    <div class="text-subtitle-2">www.remexcorp.com</div>
                  </div>
                  <v-img max-height="70" max-width="150" src="http://erp-demo.datascapeit.com/uploads/settings/logo/Datascape_Group_All_Main_Logofgd-1.png" contain></v-img>
                </v-card>
              </v-col>
              <v-col cols="12">
                <h4 class="d-flex justify-center center"><strong>Invoice</strong></h4>
                <v-row class="justify-space-between">
                  <v-col cols="8">
                    <p><strong>Invoice No:</strong><span>SO001</span></p>
                    <p><strong>Date:</strong><span>2025-10-12</span></p>
                    <p><strong>Contact Person:</strong> <span>Md. Faruk</span></p>
                    <p><strong>Company Name:</strong><span>Quality Mineral Industriesk</span></p>
                    <p><strong>Company Address:</strong><span>40, Haider Box Lane, Urdu Road, Dhaka-1211, Bangladesh</span></p>
                    <p><strong>Company Phone: </strong><span>01714-223707</span></p>
                  </v-col>
                  <v-col cols="4" class="text-right">
                    <h4><strong>Reference No:</strong>SO001</h4>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="px-4">
                <br>
              </v-col>
            </v-row>
            <v-table class="mt-1" width="100%">
              <thead>
                <tr>
                  <th>SN</th>
                  <th>Code</th>
                  <th>Item</th>
                  <th class="text-center">Quantity</th>
                  <th class="text-center">Unit</th>
                  <th class="text-center">Rate</th>
                  <th class="text-center">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>pro002</td>
                  <td>Polyglycerol Polyricinoleate (PGPR)</td>
                  <td class="text-center">1</td>
                  <td class="text-center">Pound</td>
                  <td class="text-center">60</td>
                  <td class="text-right">60</td>
                </tr>
                <v-divider></v-divider>
              </tbody>
            </v-table>
            <v-row class="py-10">
              <v-col cols="9">
                <p class="text-right">Subtotal</p>
                <p class="text-right">Discount (0.00%)</p>
                <p class="text-right">VAT (0.00%) Excluded</p>
                <p class="text-right">TAX (0.00%) Excluded</p>
                <v-row class="font-weight-bold justify-space-between px-3 py-4">
                  <p colspan="3"><strong>Amount in word:</strong> SIXTY ONLY.</p>
                  <p class="text-right">Total</p>
                </v-row>
              </v-col>
              <v-col cols="3">
                <p class="text-right font-weight-bold">60</p>
                <p class="text-right font-weight-bold">0.00</p>
                <p class="text-right font-weight-bold">0.00</p>
                <p class="text-right font-weight-bold">0.00</p>
                <p class="text-right font-weight-bold">60</p>
              </v-col>
            </v-row>
            <v-row class="px-4">
              <p>Received the Above goods in actual weight and good condition</p>
            </v-row>
            <v-row class="px-4">
              <p><strong>Receiver's Signature</strong></p>
              <p><strong>Authorized Signature</strong></p>
            </v-row>
            <v-row class="text-center mt-6">
                <v-btn color="primary" href="http://localhost:8000/purchase/make_po_invoice_pdf/SO001" target="_blank">
                    <v-icon left>mdi-file-pdf-box</v-icon> Print PDF
                </v-btn>

                <v-btn color="success" href="/purchase/make_po_invoice_pdf/SO001?download=true">
                    <v-icon left>mdi-file-download</v-icon> Download PDF
                </v-btn>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      firstCompany: {
        name: "Remex Corporation Ltd.",
        address: "Red Crescent Concord Tower 17, Unit 10/B, Mohakhali C/A, Dhaka-1212, Bangladesh",
        mobile: "+88-02222288648, +88-02222289278",
        email: "info@remexcorp.com",
      },
      invoiceData: {
        id: "SO001",
        create_date: "2025-10-12",
        contact_name: "Md. Faruk",
        company_name: "Quality Mineral Industriesk",
        company_address: "40, Haider Box Lane, Urdu Road, Dhaka-1211, Bangladesh",
        company_phone: "01714-223707",
        ref_no: "SO001",
        sub_total: "60",
        discount_amount: "0.00",
        vat_amount: "0.00",
        tax_amount: "0.00",
        cart: [
          {
            product: { name: "Polyglycerol Polyricinoleate (PGPR)", code: "pro002" },
            qty: 1,
            rate: 60,
            total: 60,
            product: { unit: { name: "Pound" } },
          },
        ],
      },
    };
  },
  computed: {
    grandTotalInWords() {
      return "SIXTY ONLY.";
    },
  },
};
</script>